import styles from './MaskOverlay.module.scss';

import { noop } from 'lodash';
import React from 'react';

import { DummyOverlay } from '@work4all/components/lib/dataDisplay/dummy-overlay';

import { Form } from './components/form';
import { MaskOverlayHeader } from './components/MaskOverlayHeader/MaskOverlayHeader';
import { MaskContextProvider } from './hooks/mask-context';

export const RestOverlay: React.FC = () => {
  return (
    <MaskContextProvider
      value={{
        entity: null,
        isCreateMode: true,
        isEditMode: false,
        mode: 'create',
        params: null,
        wip: true,
      }}
    >
      <Form className={styles.maskForm} onSubmit={noop}>
        <MaskOverlayHeader title={'Not yet implemented'} tabs={null} />
        <div className={styles.tabsWrapper}>
          <DummyOverlay type={'todo'} />
        </div>
      </Form>
    </MaskContextProvider>
  );
};
